import React from 'react'
import {useDrag} from 'react-dnd'
import {Consumer} from '../../context'

export const homeworkColor = '#93e2c6'
export const assessmentColor = '#c98571'

import './event.styl'

export default function Event (props) {
  const title = props.content.title || props.title
  const isAssessment = ['quiz', 'a.assignment'].indexOf(props.type) >= 0
  const isHomework = props.type == 'homework'
  const [{ opacity }, dragRef] = useDrag({
    item: { type: 'event', id: props.id },
    collect: monitor => ({
      opacity: monitor.isDragging() ? 0.5 : 1,
    })
  })
  return (<Consumer>{ context => {
    const subject = context.subjects.find(subject => subject.id == props.content.subject)

    const color = isAssessment
      ? '#fff'
      : isHomework
        ? '#fff'
        : subject.textColor

    const backgroundColor = isAssessment
      ? assessmentColor
      : isHomework
        ? homeworkColor
        : subject.color

    return (

    <div ref={dragRef}
        className="event"
        style={{opacity, color, backgroundColor }}
      >
        <label title={title}>{title}</label>
        <div className="flex spacer" />
      </div>)
  }}</Consumer>)
}
